<template>
    <section>
        <v-layout row style="width: 90%;margin: auto;">
        <v-data-table :headers="headers" 
                      :items="GetSchedules" 
                      item-key="CourseDetails.Course_Title" 
                      class="elevation-1"
                      style="width:100%;margin-top:10px;">
            <template v-slot:headers="props">
                <tr>
                    <th v-for="header in props.headers" :key="header.text">
                    {{ header.text }}
                    </th>
                </tr>
            </template>
            <template v-slot:items="props">
                <tr>
                    <td class="text-xs-center">{{ props.item.CourseDetails.Course_Title }}</td>
                    <td class="text-xs-center">{{ ScheduleTypeLabel(props.item.Schedule_Type) }}</td>
                    <td class="text-xs-center">{{ new Date(props.item.Schedule_Start_Date).toDateString() }}</td>
                    <td class="text-xs-center">{{ new Date(props.item.Schedule_End_Date).toDateString() }}</td>
                    <td class="text-xs-center">{{ props.item.Enable }}</td>
                    <td class="text-xs-center">
                        <v-btn color="primary" icon class="btnAction" @click="OpenUpdateDialog(props.item)">
                            <v-icon>edit</v-icon>
                        </v-btn>
                        <v-btn color="error" icon class="btnAction" @click="DeleteSchedule(props.item)">
                            <v-icon>delete</v-icon>
                        </v-btn>
                    </td>
                </tr>
            </template>
        </v-data-table>
            <app-add-schedule ref="SetUpdateSchedule" :dialog='UpdateSchedule' @close='CloseDialog'></app-add-schedule>
        </v-layout>
    </section>
</template>
<script>

import appAddSchedule     from '../dialogs/AddSchedule'
import { ScheduleTypeLabel } from '../../util/courseTypes'

export default {
    components:{
        appAddSchedule
    },
    data(){

        return {

            headers              : [ { text: 'Course Name',value: 'CourseDetails.Course_Title' },
                                     { text: 'Schedule Type',value: 'Schedule_Type' },
                                     { text: 'Schedule Start Date',value: 'Schedule_Start_Date' },
                                     { text: 'Schedule End Date',value: 'Schedule_End_Date' },
                                     { text: 'Active',value: 'Enable' },
                                     { text: 'Actions' } ],
            UpdateSchedule       : false,
        }
    },
    computed:{
        GetSchedules(){

            return this.$store.getters.GetSchedules
        }
    },
    methods:{
      ScheduleTypeLabel,
      OpenUpdateDialog(Schedule){
          if(Schedule['Schedule_Type'] == 'Classroom'){

              this.$refs.SetUpdateSchedule.SetScheduleType("Classroom")
          }else{

              this.$refs.SetUpdateSchedule.SetScheduleType("Webinar")
          }

          this.$refs.SetUpdateSchedule.SetUpdateStatus(Schedule)
          this.UpdateSchedule = true
      },
      CloseDialog(){

        this.UpdateSchedule = false
        
      },
      DeleteSchedule(Schedule){
        if (confirm("Do you really want to delete?")) {
          let data = {}
          data['Schedule_Id'] = Schedule['_id']

          this.$http.post(`${this.$store.getters.GetProductionUrl}/schedules/deleteschedules`,data)
              .then(response =>{
                  
                  this.$store.commit('DeleteIndividualSchedules',response["data"]["response"])
              })
              .catch(err =>{

                  this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Deleting Schedule","Color":"red","Close": false });
              })
          }
        }
    },
    mounted(){

        this.$http.post(`${this.$store.getters.GetProductionUrl}/schedules/getschedules`)
                    .then(response =>{
                        
                        this.$store.commit('SetSchedules',response["data"]["response"])
                    })
                    .catch(err =>{

                        this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                    })
    }
}
</script>
<style scoped>
.btnAction{
    margin: 4px;
    border: 1px solid #d3d3d37a;
}
</style>


